/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-01-06 17:31:00
 */

import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import {CameraAlarmDOI} from "./api/cameraAlarmApi";
import CameraAlarmService from "./service/cameraAlarmService";
import './cameraAlarm.less';

@Component({name: 'camera-alarm'})
export default class CameraAlarm extends BasicSearchPage<CameraAlarmService, CameraAlarmDOI.RowDataI, CameraAlarmDOI.QueryRowDataParamsI> {

    @override
    renderHead(h) {
        return <div></div>
    }
    
    @override
    loadService () {
        this.service = new CameraAlarmService(this)
    }
}